import { UpgradeDistance } from '../../../../../shared/vulns/types';
import { icons } from '../../../generic/Icon';
import type { IconClassName } from '../../../generic/Icon';

/** Badge icon + label for each upgrade distance, shared by the fossabot remediation boxes. */
export const UPGRADE_BADGE: Record<UpgradeDistance, { icon: IconClassName; label: string }> = {
  [UpgradeDistance.MAJOR]: { icon: icons.majorFix, label: 'Major Upgrade' },
  [UpgradeDistance.MINOR]: { icon: icons.minorFix, label: 'Minor Upgrade' },
  [UpgradeDistance.PATCH]: { icon: icons.patchFix, label: 'Patch Upgrade' },
};
